module.exports = __webpack_public_path__ + "img/armasuisse_nan.4b99ece6.jpg";